import type { ComponentChildren, FunctionalComponent } from 'preact';

import { cnMultilineText } from './multiline-text.constants.js';

import './multiline-text.css';

type BlockAttributes = {
    children: ComponentChildren;
    tag?: 'div' | 'span' | 'p' | 'sub' | 'h1' | 'h2' | 'h3';
    className?: string;
};

export interface MultilineTextProps extends BlockAttributes {}

export const MultilineText: FunctionalComponent<MultilineTextProps> = (props) => {
    const { children, className, tag: Component = 'div' } = props;

    return <Component className={cnMultilineText({}, [className])}>{children}</Component>;
};
